import * as React from "react";
import { Row } from "components/bootstrap";
import { DocumentTitle } from "components/common";
import PageNavigation from "components/common/PageNavigation";
import { PAGE_NAV_TITLE as SYSTEM_PAGE_NAV_TITLE } from "components/system-overview/bindings";
import HealthModule from "./HealthModule";
const HealthPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "System Health" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: SYSTEM_PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(HealthModule, null)));
export default HealthPage;
